// extracted by mini-css-extract-plugin
export default {"subTitle":"i2Y9HoeNBhOKqaSmooovWA==","indent":"_3AcQpoufd6SA0basWjUlPA==","button":"qGaeu-cvqGRp14gi0xueTA==","buttonsContainer":"_0n9ZnT7L4xk7q5hGA+oYCg=="};